import React from "react";
import { formatMoney } from "@/lib/api";

const TIER_LABELS = { basico: "Básico", normal: "Estándar", premium: "Premium" };

export default function PriceSidebar({ breakdown, state, config }) {
    const lines = breakdown?.lines || [];
    const provLines = lines.filter((l) => l.key.startsWith("prov_"));
    const otherLines = lines.filter((l) => !l.key.startsWith("prov_"));
    return (
        <aside className="sticky top-8 bg-white border border-border p-6 lg:p-8" data-testid="price-sidebar">
            <div className="overline text-muted-foreground">Cotización en vivo</div>
            <div className="mt-4 flex items-baseline justify-between">
                <h3 className="font-display text-3xl leading-none">Tu inversión</h3>
                <span className="overline px-2 py-1 border border-border text-muted-foreground tabular" data-testid="sidebar-guests">
                    {state.guests || 0} pax
                </span>
            </div>

            {breakdown?.season && (state.guests > 0) && (
                <div className={`mt-3 overline text-[10px] ${breakdown.season === "alta" ? "text-accent" : "text-eucalyptus"}`} data-testid="sidebar-season">
                    Temporada {breakdown.season === "alta" ? "Alta" : "Baja"}
                </div>
            )}

            {breakdown?.staff && (
                <div className="mt-4 text-xs text-muted-foreground border-l-2 border-accent pl-3">
                    Incluye <strong className="text-accent">{breakdown.staff} personas</strong> de personal operativo (aseo + parqueadero — no incluye seguridad).
                </div>
            )}

            <div className="mt-6 border-t-2 border-foreground pt-4 flex items-baseline justify-between">
                <span className="overline">Total referencial</span>
                <span className="font-display text-4xl tabular" data-testid="quote-total">
                    {formatMoney(breakdown?.total || 0)}
                </span>
            </div>

            {/* Proveedores elegidos: siempre visibles (sin clic adicional) */}
            {provLines.length > 0 && (
                <div className="mt-4 border-t border-border pt-3 space-y-2" data-testid="sidebar-providers">
                    <div className="overline text-[10px] text-muted-foreground">Tus proveedores</div>
                    {provLines.map((l) => (
                        <div key={l.key} className="flex justify-between items-baseline gap-2 text-xs">
                            <span className="truncate">
                                <span className="text-muted-foreground">{l.category}: </span>
                                <span className="font-medium">{l.brand || l.provider_name}</span>
                                {l.tier && <span className="ml-1 text-[10px] overline text-accent">{TIER_LABELS[l.tier] || l.tier}</span>}
                            </span>
                            <span className="tabular whitespace-nowrap">{formatMoney(l.amount || 0)}</span>
                        </div>
                    ))}
                </div>
            )}

            {otherLines.length > 0 && (
                <details className="mt-4 border-t border-border pt-3" data-testid="sidebar-detail">
                    <summary className="cursor-pointer overline text-[10px] text-accent select-none">Ver detalle completo ▾</summary>
                    <div className="mt-3 space-y-1.5 text-xs max-h-72 overflow-y-auto">
                        {otherLines.map((l) => (
                            <div key={l.key} className="flex justify-between gap-2">
                                <span className="text-muted-foreground truncate">{l.label}</span>
                                <span className="tabular whitespace-nowrap">{formatMoney(l.amount || 0)}</span>
                            </div>
                        ))}
                    </div>
                </details>
            )}

            <p className="mt-4 text-xs font-medium text-accent leading-snug border-l-2 border-accent pl-3">
                Precios referenciales — cada proveedor realizará una recotización formal según tus especificaciones.
            </p>
        </aside>
    );
}
